var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("PageHeader", { attrs: { title: _vm.headerTitle, "no-padding": "" } }),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-actions",
            { staticClass: "card-bg-2 py-0 layout wrap", attrs: { wrap: "" } },
            [
              _c("DownloadReport", {
                attrs: {
                  disabled: false,
                  reportParams: _vm.reportParams,
                  reportName: _vm.headerTitle,
                },
                on: {
                  loading: function ($event) {
                    _vm.loading.report = $event
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c("v-card-title", { staticClass: "headline pb-0" }, [
            _vm._v("Report Type"),
          ]),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "py-0" },
            [
              _c(
                "v-radio-group",
                {
                  attrs: { disabled: _vm.loading.report, row: "" },
                  model: {
                    value: _vm.reportParams.reportType,
                    callback: function ($$v) {
                      _vm.$set(_vm.reportParams, "reportType", $$v)
                    },
                    expression: "reportParams.reportType",
                  },
                },
                [
                  _vm._l(_vm.availableReportTypes, function (reportType) {
                    return [
                      _c("v-radio", {
                        key: reportType.value,
                        staticClass: "mr-4",
                        attrs: {
                          color: "info",
                          label: reportType.text,
                          value: reportType.value,
                        },
                      }),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-card-title", { staticClass: "headline pb-0" }, [
            _vm._v("Date Range"),
          ]),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "py-0", staticStyle: { "max-width": "600px" } },
            [
              _c("DateRange", {
                ref: "dateRange",
                attrs: {
                  disabled: _vm.loading.report,
                  hideClear: "",
                  relativeDate: _vm.dates.start,
                  rounded: "",
                  solo: "",
                  maxDate: _vm.maxDate,
                  shortcuts: _vm.reportShortcuts,
                  selectedRange: _vm.selectedRange,
                  "no-arrows": "",
                  includeDefaultShortcuts: false,
                  calculateSelectedRange: false,
                },
                on: {
                  "update:selectedRange": function ($event) {
                    return _vm.updateSelectedRange($event)
                  },
                },
                model: {
                  value: _vm.dates,
                  callback: function ($$v) {
                    _vm.dates = $$v
                  },
                  expression: "dates",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-card-title", { staticClass: "headline pb-0" }, [
            _vm._v("Include QA/QC sample data"),
          ]),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "py-0" },
            [
              _c(
                "v-radio-group",
                {
                  attrs: { disabled: _vm.loading.report, row: "" },
                  model: {
                    value: _vm.reportParams.includeQaQc,
                    callback: function ($$v) {
                      _vm.$set(_vm.reportParams, "includeQaQc", $$v)
                    },
                    expression: "reportParams.includeQaQc",
                  },
                },
                [
                  _c("v-radio", {
                    staticClass: "mr-4",
                    attrs: { color: "info", label: "Yes", value: true },
                  }),
                  _vm._v(" "),
                  _c("v-radio", {
                    staticClass: "mr-4",
                    attrs: { color: "info", label: "No", value: false },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }